<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1250px'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Chuyển xử lý văn bản đến
        </h2>
        &nbsp;&nbsp;
        <div class="title-content">
          <el-tag class="priority lv3">
            {{ quote }}
          </el-tag>
        </div>
      </div>
      <!-- body -->

      <el-tabs v-model="activeTabName">
        <el-tab-pane label="Chuyển Lãnh đạo duyệt" name="firstTab">
          <el-row class="dialog-body margin-0" :gutter="24">
            <el-col :span="12" class="list-collapse__transfer">
              <div class="flex-row flex__left margin-bottom-10">
                <el-input
                  prefix-icon="el-icon-search"
                  size="medium"
                  placeholder="Tìm kiếm theo tên/emai/đơn vị/chức vụ"
                  @input="searchTree"
                  v-model="filter.query"
                ></el-input>
              </div>
              <hashtag-common
                :stepId="stepId"
                @selectTags="selectHashTag"
              />
              <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
                <el-tree
                  v-loading="isLoadingRoots"
                  :data="roots1"
                  :filter-node-method="filterNode"
                  ref="departmentTree"
                  class="filter-tree"
                  :default-expanded-keys="defaultExpandKeys"
                  node-key="id"
                  show-checkbox
                  check-strictly
                  @check-change="checkChange"
                >
                  <div
                    class="custom-tree-node flex-row flex__between width__100"
                    slot-scope="{ node, data }"
                  >
                    <div class="field-1">
                      <span>
<!--                        <el-checkbox-->
<!--                          v-model="data.checked"-->
<!--                          @change="checkedChangeEvent(data)"-->
<!--                        ></el-checkbox>-->
                        <span
                          v-if="
                            data.nodeType ===
                              DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                          "
                        >
                          <span class="font-weight__bold">
                            {{ data.userDeptRole.fullName }}
                          </span>

                          <span class="font-size__small font-italic">
                            ({{ data.userDeptRole.positionName }})
                          </span>
                           <span style="position: relative">
                               <el-tooltip
                                 v-if="data.userDeptRole.absentCount&&data.userDeptRole.absentCount!=0"
                                 :content="tooltipContent(data.userDeptRole)"
                                 placement="right"
                                 effect="dark">
                               <absent-notify></absent-notify>
                             </el-tooltip>
                          </span>
                        </span>
                        <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                      </span>
                    </div>
                  </div>
                </el-tree>
              </VuePerfectScrollbar>
            </el-col>
            <el-col :span="12" class="display-list__selected">
              <!-- chuyen xu ly -->
              <div
                :class="['list-selected', isLanhDao ? 'withAutoAssignTask' : '']"
              >
                <!-- title -->
                <div class="header">
                  <div class="flex-row flex__between">
                    <h5 class="title margin-0">Danh sách chuyển xử lý</h5>
                    <div class="list-checkbox flex-row flex__right margin-right-10">
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Chủ trì</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.CHUTRI"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          ></el-radio>
                        </span>
                      </h5>
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Phối hợp</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.PHOIHOP"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          >
                          </el-radio>
                        </span>
                      </h5>
                      <h5
                        class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                      >
                        <span class="margin-bottom-5">Nhận để biết</span>
                        <span>
                          <el-radio
                            v-model="processType"
                            :label="PROCESS_TYPE.NHANDEBIET"
                            @change="checkAllProcessType"
                            class="radio_chuyenXuLy"
                          >
                          </el-radio>
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>
                <!-- end_title -->
                <div class="body">
                  <div class="list-filter">
                    <VuePerfectScrollbar
                      class="scroll-list-user"
                      :settings="perfectScrollbarSetting"
                    >
                      <div
                        v-for="(item, index) in selectedHandlersData"
                        :key="index"
                        class="selected-user flex-row flex__between"
                      >
                        <div class="title flex-row flex__left">
                          <div class="clickable margin-right-10">
                            {{ index + 1 }}.
                          </div>
                          <div
                            class="flex-row flex__left"
                            v-if="
                              item.data.nodeType ===
                                DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                            "
                          >
                            <div class="avt">
                              <div
                                class="avatar-fake font-size__small margin-right-10 flex-row flex__center"
                              >
                                <span>{{
                                    item.data.userDeptRole.fullName
                                      | buildShortNameFilter
                                  }}</span>
                              </div>
                            </div>
                            <div class="info">
                              <p class="people__name">
                                {{ item.data.userDeptRole.fullName }}
                              </p>

                              <p class="people__position margin-0">
                                {{ item.data.userDeptRole.positionName }} -
                                {{ item.data.userDeptRole.deptName }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="flex-row flex__left"
                            v-else-if="
                              item.data.nodeType === DEPARTMENT_TREE.NODE_TYPE.DEPT
                            "
                          >
                            <div class="avt"></div>
                            <div class="info">
                              <p class="people__name">
                                {{ item.data.department.deptName }}
                              </p>
                              <p class="people__position margin-0">
                                ({{ item.data.department.identityCode }})
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="list-checkbox flex-row flex__right margin-right-10"
                        >
                          <template>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.CHUTRI"
                              @change="refreshProcessType()"
                            >&nbsp;
                            </el-radio>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.PHOIHOP"
                              @change="refreshProcessType()"
                            >
                              &nbsp;
                            </el-radio>
                            <el-radio
                              class="item txt-center"
                              v-model="item.processType"
                              :label="PROCESS_TYPE.NHANDEBIET"
                              @change="refreshProcessType()"
                            >
                              &nbsp;
                            </el-radio>
                          </template>

                          <i
                            class="icon-close color__red clickable font-size__medium el-icon-circle-close"
                            @click="removeSelectedHandlersData(item)"
                          ></i>
                        </div>
                      </div>
                    </VuePerfectScrollbar>
                  </div>
                </div>
              </div>
              <el-form label-position="top">
                <el-form-item label="Ý kiến/đề xuất">
                  <el-input
                    type="textarea"
                    resize="none"
                    :autosize="{ minRows: 2, maxRows: 2 }"
                    placeholder="_"
                    v-model="form.note"
                  />
                </el-form-item>
<!--                <el-tooltip-->
<!--                  v-if="isLanhDao"-->
<!--                  content="Khi chuyển văn bản, công việc sẽ được tạo tự động cho đơn vị/cá nhân chủ trì"-->
<!--                  placement="top"-->
<!--                >-->
<!--                  <el-checkbox class="margin-top-5" v-model="form.isAutoAssignTask"-->
<!--                  >Tự động giao việc-->
<!--                  </el-checkbox>-->
<!--                </el-tooltip>-->
              </el-form>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading'
            ]"
          ></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
import constants from "../../../constants";
import h from "../../../services/h";
import HashtagCommon from "./chuyenXuLy-hashtag";
import cxlVbdenCommonMixin from "../../../mixins/cxlVbdenCommonMixin";
import AbsentNotify from "../../common/absents/absent-notify";
import dateFormatter from "../../../filters/dateFormatter";
import departmentService from "../../../services/departmentService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import vbIncomingChoCxlProcessService from "../../../services/vbIncomingChoCxlProcessService";
import utils from "../../../services/utils";

export default {
  name: "cxl-vbden-ld-duyet",
  mixins: [cxlVbdenCommonMixin],
  filters: {buildShortNameFilter},
  props: [
    "flowId",
    "stepId",
    "flag",
    "docId",
    "isOpen",
    "quote",
    "incomingProcessId",
    "nextVbIncomingProcess",
    "note",
    "isProcessing",
    "defaultProcessType"
  ],
  components: {
    AbsentNotify,
    HashtagCommon,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
    VuePerfectScrollbar
  },

  data() {
    return {
      activeTabName: 'firstTab',
      roots1: [],
      selectedHandlers: [],
      isLoadingRoots: true,
      defaultExpandKeys: [],
      nextSteps: null,
      filter: {
        query: null,
        showChecked: false
      }
    }
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isLanhDao() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
      );
    },
    isNhanhDang() {
      return (
        this.userDeptRole &&
        this.userDeptRole.deptPath.includes('/TCT/DU', 0)
      );
    },
    isChoDuyetCxl() {
      return this.flag === constants.STEP.FLAG_CHO_DUYET_CXL;
    },
    isDuyetCxl() {
      return this.flag === constants.STEP.FLAG_DUYET_CXL;
    }
  },

  watch: {},

  created() {
    this.initForm()
  },

  methods: {
    tooltipContent(item){
      return `Vắng mặt từ `+dateFormatter(item.absentStartTime)+` đến `+dateFormatter(item.absentDeadlineTime);
    },
    checkedChangeEvent(data) {
      this.checkedChange(
        data,
        data.isHandlerNode
          ? constants.PROCESS_TYPE.CHUTRI
          : this.defaultProcessType || constants.PROCESS_TYPE.NHANDEBIET
      );
    },

    async initForm() {
      this.form.note = this.note;
      await this.initSelectedHandlers();
      await this.buidNodesCXLList();
      this.loadNextStepsInfo(this.flowId, this.stepId)
          .then(response => this.nextSteps = response);
      this.markCheckedForSelectedHandlers();
    },

    // Load va build node danh sach chuyen xu ly
    // buidNodesCXLList() {
    //   if(this.roots1.length !== 0) return;
    //   return this.loadNextStepsInfo(this.flowId, this.stepId)
    //     .then(nextSteps => {
    //       this.nextSteps = nextSteps;
    //       return this.loadHandlers(this.stepId, nextSteps);
    //     })
    //     .then(results => {
    //       let userDeptRolesSet = results[0];
    //       let departments = results[1];
    //       this.userDeptRoleHandlers = userDeptRolesSet;
    //       this.departmentHandlers = departments;
    //       this.filterAllAlreadyForwardedHandlers();
    //       this.buildNodes().then(() => {
    //         this.roots1 = [...this.roots];
    //         h.each(this.roots1, root =>
    //           this.markCheckedForSelectedHandlers(root)
    //         );
    //         this.refreshProcessType();
    //       });
    //     });
    // },

    buidNodesCXLList() {
      if(this.roots1.length !== 0) return;

      this.userDeptRoleHandlers = [];
      this.departmentHandlers = [];

      let promises = null;
      if (this.isNhanhDang ) {
        let arr = [
          this.loadDepartmentHandlers(constants.DANG_UY_TCT_DEPT_CODE),
          this.loadHandlersForDang_()
        ];
        if (this.$store.getters.user.tenantCode === 'vinataba.com.vn'){
          arr = [
            this.loadDepartmentHandlers(constants.DANG_UY_TCT_DEPT_CODE),
            this.loadHandlersForDang_(),
            this.loadDepartmentHandlers(this.$store.getters.globalRoles),
            this.loadHandlers_(),
          ];
        }
        promises = Promise.all(arr);
      } else {
        promises = Promise.all([
          this.loadDepartmentHandlers(this.$store.getters.globalRoles),
          this.loadHandlers_()
        ]);
      }
      return promises.then(() => {
        // this.filterAllAlreadyForwardedHandlers(); // bỏ code này để load ra cả người được chuyển ở bước sau
        return this.buildNodes().then(() => {
          this.roots1 = [...this.roots];

          // Bỏ node ROOT
          this.roots1 = this.removeNodeROOT(this.roots1);
          // chuyen userDeptRole trong TCT xuong cuoi tree
          this.roots1 = this.moveUserOfTCTToBottom(this.roots1);

          // h.each(this.roots1, root => {
          //   this.markCheckedForSelectedHandlers(root);
          // });

          this.refreshProcessType();
          this.isLoadingRoots = false;

          this.defaultExpandKeys.push(this.roots1[0].id); // Expand root node
          this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD); // Expand root node
          this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.PBCN); // Expand root node
          this.defaultExpandKeys.push(constants.DEPARTMENT_TREE.NODE_TYPE.DVTT); // Expand root node
        });
      });
    },

    searchTree() {
      setTimeout(() => this.$refs.departmentTree.filter(this.filter), 200)
    },

    async loadDepartmentHandlers(deptCode) {
      let departmentHandlersTmp = [];
      await departmentService.findAllByDeptCodeAndIncludeSubDepts(deptCode)
        .then(response => (departmentHandlersTmp.push(...response.data)));
      if (this.departmentHandlers){
        this.departmentHandlers.push(...departmentHandlersTmp);
      } else {
        this.departmentHandlers = departmentHandlersTmp;
      }
      // console.log('this.departmentHandlers', this.departmentHandlers)
      return this.departmentHandlers;
    },

    async loadHandlersForDang_() {
      let userDeptRoleHandlers = [];
      await userDeptRoleViewService.findAllLanhDaoByDeptCode(constants.DANG_UY_TCT_DEPT_CODE)
        .then(response => (userDeptRoleHandlers.push(...response.data)));
      await userDeptRoleViewService.findAllByDeptCode(constants.TTDU_DEPT_CODE)
        .then(response => (userDeptRoleHandlers.push(...response.data)));
      if(this.userDeptRoleHandlers){
        let userDeptRoleHandlersTmp = [];
        h.each(userDeptRoleHandlers, item => {
          let check = h.exists(this.userDeptRoleHandlers, item2 => item2.id === item.id);
          if (!check){
            userDeptRoleHandlersTmp.push(item);
          }
        });
        this.userDeptRoleHandlers.push(...userDeptRoleHandlersTmp);
      }else{
        this.userDeptRoleHandlers = userDeptRoleHandlers;
      }
    },

    async loadHandlers_() {
      let userDeptRoleHandlers = [];
      if (this.$store.getters.user.tenantCode === 'vinataba.com.vn') {
        await userDeptRoleViewService.findAll({
          status: constants.STATUS_.ACTIVE,
          usersStatus: constants.STATUS_.ACTIVE,
          deptStatus: constants.STATUS_.ACTIVE
        }).then(response => (userDeptRoleHandlers.push(...response.data)));
      } else {
        await userDeptRoleViewService.findAllByDeptCode(constants.HDTV_DEPT_CODE)
          .then(response => (userDeptRoleHandlers.push(...response.data)));
        await userDeptRoleViewService.findAllLanhDaoByDeptCode(this.$store.getters.globalRoles)
          .then(response => (userDeptRoleHandlers.push(...response.data)));
      }
      if(this.userDeptRoleHandlers.length > 0){
        let userDeptRoleHandlersTmp = [];
        h.each(userDeptRoleHandlers, item => {
          let check = h.exists(this.userDeptRoleHandlers, item2 => item2.id === item.id);
          if (!check){
            userDeptRoleHandlersTmp.push(item);
          }
        });
        this.userDeptRoleHandlers.push(...userDeptRoleHandlersTmp);
      } else {
        this.userDeptRoleHandlers = userDeptRoleHandlers;
      }
    },

    // loadNextStepsInfo(flowId, stepId) {
    //   return nextStepInfoViewService
    //     .nextSteps(flowId, stepId)
    //     .then(response => this.nextSteps = response.data);
    // },

    markCheckedForSelectedHandlers() {

      const checkedNodes = h.collect(this.selectedHandlers, item => {
        return this.$refs.departmentTree.getNode(item.id);
      });
      for (const node of checkedNodes) {
        this.$refs.departmentTree.setChecked(node.data.id, true);
        this.checkChange(node.data, true);
        const parentNode = node.parent;
        parentNode.expanded = true;
      }
    },

    removeSelectedHandlersData(item) {
      const data = this.$refs.departmentTree.getNode(item.data.id);
      this.$refs.departmentTree.setChecked(data, false);
    },

    filterAllAlreadyForwardedHandlers() {
      this.userDeptRoleHandlers = h.findAll(
        this.userDeptRoleHandlers,
        userDeptRole =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              (process.receiverUserDeptRoleId === userDeptRole.id ||
                (process.receiverId === userDeptRole.userId &&
                  process.deptReceiverId === userDeptRole.deptId &&
                  process.roleReceiverId === userDeptRole.roleId))
          ) === -1
      );

      this.departmentHandlers = h.findAll(
        this.departmentHandlers,
        department =>
          h.indexOf(
            this.nextVbIncomingProcess,
            process =>
              process.stepType === constants.STEP.STEP_TYPE.DONVI &&
              process.deptReceiverId === department.id
          ) === -1
      );
    },

    submit() {
      if (!this.validate()) return;
      const handlersData = this.processSelectedHandlerData(this.selectedHandlersData);
      this.$emit("submit",
        {
          handlersData: handlersData,
          note: this.form.note,
          isAutoAssignTask: this.form.isAutoAssignTask
        }
      );
    },

    processSelectedHandlerData(selectedHandlersData) {
      let handlersData = [];
      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType ===
            constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
        )
        .forEach(item => {
          handlersData.push({
            userDeptRole: item.data.userDeptRole,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.CANHAN
          });
        });

      selectedHandlersData
        .filter(
          item =>
            item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
        )
        .map(item => {
          handlersData.push({
            department: item.data.department,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.DONVI
          });
        });
      return handlersData;
    },

    initSelectedHandlers() {
      /*
      * Chỉ load checkedHandler khi flag là: DUYET_CXL
      * */
      if(this.flag !== constants.STEP.FLAG_DUYET_CXL) return;

      return vbIncomingChoCxlProcessService.findAllByDocId(this.docId)
      .then(response => {
        const handlers = response.data;
        const deptHandlers = h.findAll(handlers, item => item.stepType === constants.STEP.STEP_TYPE.DONVI);
        const userDeptRoleHandlers = h.findAll(handlers, item => item.stepType === constants.STEP.STEP_TYPE.CANHAN);

        h.each(deptHandlers, item => this.selectedHandlers.push({
          id: item.deptReceiverId,
          stepType: constants.STEP.STEP_TYPE.DONVI,
          department: {
            id: item.deptReceiverId
          },
          processType: item.processType
        }));

        h.each(userDeptRoleHandlers, item => this.selectedHandlers.push({
          id: item.receiverUserDeptRoleId,
          stepType: constants.STEP.STEP_TYPE.CANHAN,
          userDeptRole: {
            id: item.receiverUserDeptRoleId
          },
          processType: item.processType
        }));
      })
    },

    // remove ROOT node
    removeNodeROOT(root) {
      if (root.length > 0 && root[0].nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
        root[0].department.deptCode === constants.ROOT_DEPT_CODE) {
        const rootChildrenNode = root[0].children;
        const tctNode = rootChildrenNode.filter(item => item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && item.department.deptCode === this.$store.getters.globalRoles)
        root = tctNode;
      }
      return root;
    },

    // chuyen userDeptRole trong TCT xuong cuoi tree
    moveUserOfTCTToBottom(root) {
      let childrenNodes = root[0].children;
      const userDeptRoleNodes = h.findAll(childrenNodes, item => item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE);

      for (const node of userDeptRoleNodes) {
        const index = childrenNodes.indexOf(node);
        if (index > -1) {
          childrenNodes.splice(index, 1); // 2nd parameter means remove one item only
          childrenNodes.push(node);
        }
      }
      // root[0].children = root[0].children.concat(userDeptRoleNodes)
      return root;
    },

    checkChange(data, isChecked) {
      const node = this.$refs.departmentTree.getNode(data);

      if (this.isBTGDAndHDTV(data) || this.isPBCNAndDVTT(data)) {
        this.setCheckedForChildren(data, isChecked); // set checked cho children
        if (isChecked) {
          node.expanded = isChecked;
        }
      }

      this.$set(data, 'checked', isChecked);

      if (!this.isBTGDAndHDTV(data)) {
        this.setCheckedForParent(data);
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            const selectedHandler = h.find(this.selectedHandlers, item => item.id === data.id);
            const processType = selectedHandler ? selectedHandler.processType : constants.PROCESS_TYPE.CHUTRI;
            this.addOrRemoveToSelectedHandlers(data, processType);
            break;
          default:
            break;
        }
      }

      // Nếu không check tất cả các children của Ban Tổng giám đốc, Hội đồng thành viên thì sẽ k check node của Ban Tổng giám đốc, Hội đồng thành viên
      // const parentNode = node.parent;
      // if (parentNode && this.isBTGDAndHDTV(parentNode.data) && !isChecked) {
      //   parentNode.checked = false
      // }

      if (this.filter.showChecked && !isChecked) {
        this.$refs.departmentTree.filter(this.filter);
      }
    },

    isBTGDAndHDTV(data) {
      return data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV
        || (data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT && data.department.deptCode === constants.HDTV_DEPT_CODE)
    },

    isPBCNAndDVTT(data) {
      return data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.PBCN
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DVTT
        || data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT
    },

    // Set checked cho children
    setCheckedForChildren(data, isChecked) {
      if (isChecked) {
        for (const children of data.children) {
          this.$refs.departmentTree.setChecked(children, isChecked);
          this.checkChange(children, isChecked)
        }
      } else {
        let isCheckedAllChildren = true;
        for (const children of data.children) {
          if (children.checked === false) {
            isCheckedAllChildren = false;
            break;
          }
        }
        if (isCheckedAllChildren) {
          for (const children of data.children) {
            this.$refs.departmentTree.setChecked(children, isChecked);
            // this.checkChange(children, isChecked)
          }
        }
      }
    },

    setCheckedForParent(data) {
      const parentNode = this.$refs.departmentTree.getNode(data.parent.id);
      if (parentNode && (this.isBTGDAndHDTV(parentNode.data) || this.isPBCNAndDVTT(parentNode.data))) {
        const uncheckedSiblingData = h.find(parentNode.childNodes, item => item.checked === false);
        if (!uncheckedSiblingData) {
          parentNode.checked = true;
        } else {
          parentNode.checked = false;
        }
      }
    },

    isShowProcessTypeRadio(node) {
      return this.isBTGDAndHDTV(node) && node.checked
    },

    selectHashTag(event, hashtagProcessTypeSelect) {
      for (const item of event) {
        let node;
        if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.BTGD || item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.HDTV) {
          node = this.$refs.departmentTree.getNode(item.nodeType);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
          node = this.$refs.departmentTree.getNode(item.department.id);
        } else if (item.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
          node = this.$refs.departmentTree.getNode(item.handler.id);
        }

        if (node) {
          this.$refs.departmentTree.setChecked(node.data.id, true);
          this.checkChange(node.data, true);
          const parentNode = node.parent
          parentNode.expanded = true;

          // this.expandParent();
          // this.$set(this.processTypeRadio, node.data.id, hashtagProcessTypeSelect);

        }
      }
    },

    // expand parent of checked node
    expandParent() {
      this.defaultExpandKeys.splice(0);
      this.defaultExpandKeys.push(this.roots2[0].id); // Expand root node
      const checkNodes = this.$refs.departmentTree.getCheckedNodes();
      for (const checkNode of checkNodes) {
        if (checkNode.parent) {
          this.defaultExpandKeys.push(checkNode.parent.id);
        }
      }
    },

    filterNode(value, data) {
      if (!value.query && !value.showChecked) {
        this.refreshNodeExpand();
        return true;
      }
      // return data.checked == true
      let b = true;
      if (value.query) {
        switch (data.nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            b = utils.like(data.department.deptName, value.query);
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            b = utils.filterUserDeptRoleView(value.query, data.userDeptRole);
            break;
          default:
            break;
        }
      }

      if (value.showChecked) {
        b = b && data.checked == true
      }

      return b;
    },

    findAllParentIdsOfNodeDatas(datas) {
      if (datas.length === 0) {
        return [];
      }
      let parentIds = [];
      const parentDatas = [];
      for (const data of datas) {
        if ('parent' in data && parentIds.indexOf(data.parent.id) !== 1) {
          parentDatas.push(data.parent)
          parentIds.push(data.parent.id)
        }
      }
      parentIds = parentIds.concat(this.findAllParentIdsOfNodeDatas(parentDatas))
      parentIds.filter((item,index)=>{
        return (parentIds.indexOf(item) == index)
      })
      return parentIds;
    },

    refreshNodeExpand() {
      const checkedDatas = this.$refs.departmentTree.getCheckedNodes();
      const parentIds = this.findAllParentIdsOfNodeDatas(checkedDatas);

      this.collapseAllNode(this.roots1[0]);

      for (const parentId of parentIds) {
        const node = this.$refs.departmentTree.getNode(parentId);
        if (node) {
          node.expanded = true;
        }
      }
    },

    collapseAllNode(data) {
      h.each(data.children, child =>
        this.collapseAllNode(child)
      )
      const node = this.$refs.departmentTree.getNode(data.id);
      if (node) node.expanded = false;

      // expanded default
      const rootNode = this.$refs.departmentTree.getNode(this.roots1[0].id);
      rootNode.expanded = true
      const btgdNode = this.$refs.departmentTree.getNode(constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
      btgdNode.expanded = true
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
}

.list-checkbox {
  position: relative;
  margin-right: 10px;
}

.scroll-list-user {
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.list-checkbox .item {
  width: 90px;
  text-align: center;
  margin: 0;
}

.icon-close {
  position: absolute;
  right: -5px;
  font-size: 18px;
}

.dialog-body .display-list__selected .list-selected .header > div {
  width: 100%;
}

.dialog-body .display-list__selected .list-selected .body {
  padding: 0;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  display: flex;
  flex-direction: column;
}

.dialogTransferHandling .dialog-body .scroll-area-height_90 {
  height: 100%;
  margin-bottom: 0;
  margin-right: -13px;
}

.dialog-body .display-list__selected {
  height: 400px;
}

.dialogTransferHandling .dialog-body .display-list__selected .list-selected {
  height: calc(100% - 121px);
}

.dialogTransferHandling
.dialog-body
.display-list__selected
.list-selected.withAutoAssignTask {
  height: calc(100% - 145px) !important;
}

.dialog-body .display-list__selected .list-selected .header {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-body .display-list__selected .list-selected .body .list-filter {
  height: 100%;
}

/*.dialogTransferHandling .dialog-body .list-collapse__transfer {*/
/*  height: 405px;*/
/*}*/

/*.pScrollDialog {*/
/*  height: 405px!important;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-ld-duyet.vue